<template>
    <b-container fluid class="p-3">
        <span v-if="!loadingClassChoices">
            <b-row class="no-gutters mb-4" v-if="!quickbooksData.one_class_per_line_detail">
                <b-col md="6">
                    <p>
                        Please map the following Lodgix properties to their corresponding QuickBooks Online classes (only for
                        QuickBooks Online Plus accounts):
                    </p>
                    <div class="d-flex flex-column">
                        <form-select v-for="item in classProperties" v-model="item.quickbooks_class_id"
                            :floatingLabel="item.rental_property" :key="item.id" :options="classChoicesOptions"
                            @change="value => onChangePropertyMapping(item.id, value)" />
    
                    </div>
                </b-col>
            </b-row>
            <b-row class="no-gutters mb-4" v-else>
                <b-col md="6">
                    <p>
                        Please associate the following Lodgix line details with your QuickBooks Online classes (only for
                        QuickBooks Online Plus accounts):
    
                    </p>
                    <div class="d-flex flex-column">
                        <form-select v-for="item in classMapping" v-model="item.quickbooks_class_id"
                            :floatingLabel="item.class_mapping" :key="item.id" :options="classChoicesOptions"
                            @change="value => onChangeClassMapping(item.id, value)" />
    
                    </div>
                </b-col>
            </b-row>
        </span>
        <span v-else>
            <busy-modal :show="true"></busy-modal>
        </span>
    </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import BusyModal from '../generic/busy-modal/busy-modal.vue';
import formSelect from '../generic/form-select/form-select.vue';
import api from '../../api';
import { QUICKBOOKS_ENDPOINT } from '../../endpoints';
export default {
    name: 'AccountMapping',
    components: {
        BusyModal,
        formSelect,
    },
    data() {
        return {
            classProperties: [],
            classMapping: [],
        };
    },
    computed: {
        ...mapGetters('quickbooks', ['quickbooksData', 'classChoices', 'loadingClassChoices']),
        classChoicesOptions() {
            return [
                { value: null, text: 'Undefined' },
                ...this.classChoices.map((choice) => {
                    return {
                        value: choice.id,
                        text: choice.name,
                    };
                }),
            ];
        },
    },
    mounted() {
        this.fetchMapping();
    },
    methods: {
        async onChangePropertyMapping(id, value) {
            try {
                await api.post(QUICKBOOKS_ENDPOINT(id) + 'save-class-mapping-property/', { value });
            } catch (e) {
                this.errorToast({ text: 'Could not update class mapping' });
            }
        },
        async onChangeClassMapping(id, value) {
            try {
                await api.post(QUICKBOOKS_ENDPOINT(id) + 'save-class-mapping/', { value });
            } catch (e) {
                this.errorToast({ text: 'Could not update class mapping' });
            }
        },
        async fetchMapping() {
            try {
                this.$parent.$emit('busy', true);
                const { data } = await api.get(QUICKBOOKS_ENDPOINT() + 'class-mapping/');

                this.classProperties = data.class_properties;
                this.classMapping = data.class_items;
            } catch (e) {
                this.errorToast({ text: 'Could not fetch class mapping' });
            } finally {
                this.$parent.$emit('busy', false);
            }
        },
    },
};
</script>

<style scoped>
/* Your component styles here */
</style>
